export enum FollowUpStudyVersionReason {
	Submitted = "SUBMITTED",
	Resubmitted = "RESUBMITTED",
	EditedBySupervisor = "EDITED_BY_SUPERVISOR",
	EditedByDirector = "EDITED_BY_DIRECTOR",
}
